import { createRestServiceInstance } from '@toluna-ui-toolkit/network-service';

const restService = createRestServiceInstance();
restService.setBaseUrl(window.ts?.globals?.TIM_BASEAPI_URL?.replace(/\/$/, ''));
export default restService;
